'use client';

/**
 * Spec 120 — the docs/marketing mermaid block.
 *
 * This file was a 79%-identical copy of `@repo/agent-run-ui`'s renderer:
 * same lazy-loaded parser, same failure card, same `securityLevel:
 * 'strict'` — differing only in spacing and type size for a prose
 * measure. That difference is now the shared component's `density` prop,
 * so there is one mermaid renderer and this is the one line that picks
 * the comfortable variant for MDX. `mdx-content.tsx` keeps importing
 * `./mermaid-diagram`; nothing upstream changes.
 */
import { MermaidDiagram as Base, type MermaidDensity } from '@repo/agent-run-ui/mermaid-diagram';

export function MermaidDiagram({ source, density = 'comfortable' }: { source: string; density?: MermaidDensity }) {
  return <Base source={source} density={density} />;
}
